import { useTranslation as useI18nTranslation } from 'react-i18next';

import i18n from './config';

const useTranslation = (ns?: string): { t: (text: string) => string } =>
  useI18nTranslation(ns, { i18n, useSuspense: false });

export default useTranslation;
